import { useState } from 'react';

export type ModeType = 'create' | 'edit' | 'delete';
export const useModalType = (type: ModeType = 'create') => {
  const [mode, setMode] = useState<ModeType>(type);

  return { mode, setMode };
};
